import { range } from "helper/tools";

const PageSize = process.env.REACT_APP_PAGE_SIZE;

/*
  const InitPagingInfo = { page: 1, pageSize: PageSize };
  const InitPageButtons = { name: "1", pageNumber: 1 };
  const InitResponsePagingInfo = {
    count: 0,
    isFirstPage: true,
    isLastPage: true,
    pageNumber: 0,
    totalPages: 0,
  };*/

const InitPreview =
  //Object.create({
  {
    PagingInfo: { page: 1, pageSize: PageSize },
    PageButtons: { name: "1", pageNumber: 1 },
    ResponsePagingInfo: {
      count: 0,
      isFirstPage: true,
      isLastPage: true,
      pageNumber: 0,
      totalPages: 0,
    },
  }; //);

export class Init {
  static get Vars() {
    return JSON.parse(JSON.stringify(InitPreview));
  }
}

export function buildPageButtonsInfo(response) {
  /*
  RESPONSE SEARCH INFO  searchUsuario

  const data = response.data;
    const totalPages = data.totalPages;
    const count = data.count;
    const isFirstPage = data.isFirstPage;
    const isLastPage = data.isLastPage;
    const pageNumber = data.pageNumber;*/

  const { totalPages, count, pageNumber } = response;

  let newPage = pageNumber;
  if (count === 0) {
    newPage = 1;
  }

  const MaxRangeSize = 3;
  let start = pageNumber;
  let end = start + MaxRangeSize;
  if (end > totalPages) {
    end = totalPages + 1;
    start = totalPages - (MaxRangeSize - 1);
    if (start < 1) {
      start = 1;
    }
  }

  let rangePage = range(start, end);
  if (rangePage.length === 0) {
    rangePage = [Init.Vars.PageButtons];
  } else {
    rangePage = rangePage.map((x) => ({
      name: String(x),
      pageNumber: x,
    }));
  }

  return { newPageNumber: newPage, rangePage };
}

class PagedFetch {
  constructor(pagingInfo = Init.Vars.PagingInfo) {
    this.pagingInfoRef = pagingInfo;
    this.custom = {};
  }

  updatePageNumber(pageNumber) {
    this.pagingInfoRef.page = pageNumber;
  }

  updatePageSize(pageSize) {
    this.pagingInfoRef.pageSize = pageSize;
    this.custom.pageSize = pageSize;
  }

  pageNumber() {
    return this.pagingInfoRef.page;
  }

  resetPageInfo() {
    this.pagingInfoRef = Init.Vars.PagingInfo;

    this.pagingInfoRef = { ...this.pagingInfoRef, ...this.custom };
  }

  buildFetch(criteria) {
    return { ...criteria, ...this.pagingInfoRef };
  }

  resetAndBuildPageInfo(criteria) {
    this.resetPageInfo();
    return this.buildFetch(criteria);
  }
}

export default PagedFetch;
